import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const suggestedActionsLightbox = () =>
  import(/* webpackChunkName: "4-feat-suggested-actions-lightbox" */ './SuggestedActionsLightbox');

export default lazyLoadOnRender({ loader: suggestedActionsLightbox });
